import type { ReplayReactionEvent } from '../../shared/replayReactionEvent';
import { requestJson } from './requestJson';

export async function getCreatorReplayStream(dashboardKey: string): Promise<ReplayReactionEvent[]> {
  return await requestJson(`/api/dashboard/${encodeURIComponent(dashboardKey)}/replay`);
}
